class QuickOrderForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const variantId = this.dataset.variantId;
    const shopDomain = this.dataset.shopDomain;
    const data = new FormData(this.form);

    const name = (data.get('name') || '').trim();
    const phone = (data.get('phone') || '').trim();
    const address = (data.get('address') || '').trim();
    const city = (data.get('city') || '').trim();

    if (!name || !phone || !address || !city) return;

    const nameParts = name.split(/\s+/);
    const firstName = nameParts.shift() || name;
    const lastName = nameParts.join(' ') || firstName;

    const params = new URLSearchParams();
    params.set('checkout[shipping_address][first_name]', firstName);
    params.set('checkout[shipping_address][last_name]', lastName);
    params.set('checkout[shipping_address][address1]', address);
    params.set('checkout[shipping_address][city]', city);
    params.set('checkout[shipping_address][phone]', phone);
    params.set('checkout[shipping_address][country]', 'Pakistan');

    const submitButton = this.form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      const loadingText = submitButton.dataset.loadingText;
      if (loadingText) submitButton.textContent = loadingText;
    }

    window.location.href = `https://${shopDomain}/cart/${variantId}:1?${params.toString()}`;
  }
}

if (!customElements.get('quick-order-form')) {
  customElements.define('quick-order-form', QuickOrderForm);
}
